<template>
  <div class="link-field-container" @click="handleClick"></div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'LinkField',
  emits: ['click'],
  setup(_, { emit }) {
    const handleClick = () => emit('click');
    return { handleClick };
  },
});
</script>

<style lang="scss" scoped>
.link-field-container {
  background: transparent;
  height: 100%;
  width: 100%;
  cursor: pointer;
}
</style>
